// Utilities
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    __css: function() {
        return _react.__css;
    },
    __resetCSS: function() {
        return _react.__resetCSS;
    },
    __resetStyles: function() {
        return _react.__resetStyles;
    },
    __styles: function() {
        return _react.__styles;
    },
    createDOMRenderer: function() {
        return _react.createDOMRenderer;
    },
    makeResetStyles: function() {
        return _react.makeResetStyles;
    },
    makeStaticStyles: function() {
        return _react.makeStaticStyles;
    },
    makeStyles: function() {
        return _react.makeStyles;
    },
    mergeClasses: function() {
        return _react.mergeClasses;
    },
    RendererProvider: function() {
        return _react.RendererProvider;
    },
    renderToStyleElements: function() {
        return _react.renderToStyleElements;
    },
    shorthands: function() {
        return _react.shorthands;
    },
    createCSSRuleFromTheme: function() {
        return _reactprovider.createCSSRuleFromTheme;
    },
    FluentProvider: function() {
        return _reactprovider.FluentProvider;
    },
    fluentProviderClassNames: function() {
        return _reactprovider.fluentProviderClassNames;
    },
    renderFluentProvider_unstable: function() {
        return _reactprovider.renderFluentProvider_unstable;
    },
    useFluentProvider_unstable: function() {
        return _reactprovider.useFluentProvider_unstable;
    },
    useFluentProviderContextValues_unstable: function() {
        return _reactprovider.useFluentProviderContextValues_unstable;
    },
    useFluentProviderStyles_unstable: function() {
        return _reactprovider.useFluentProviderStyles_unstable;
    },
    useFluentProviderThemeStyleTag: function() {
        return _reactprovider.useFluentProviderThemeStyleTag;
    },
    createCustomFocusIndicatorStyle: function() {
        return _reacttabster.createCustomFocusIndicatorStyle;
    },
    createFocusOutlineStyle: function() {
        return _reacttabster.createFocusOutlineStyle;
    },
    useArrowNavigationGroup: function() {
        return _reacttabster.useArrowNavigationGroup;
    },
    useFocusableGroup: function() {
        return _reacttabster.useFocusableGroup;
    },
    useFocusFinders: function() {
        return _reacttabster.useFocusFinders;
    },
    useFocusVisible: function() {
        return _reacttabster.useFocusVisible;
    },
    useFocusWithin: function() {
        return _reacttabster.useFocusWithin;
    },
    useKeyboardNavAttribute: function() {
        return _reacttabster.useKeyboardNavAttribute;
    },
    useModalAttributes: function() {
        return _reacttabster.useModalAttributes;
    },
    useObservedElement: function() {
        return _reacttabster.useObservedElement;
    },
    useFocusObserved: function() {
        return _reacttabster.useFocusObserved;
    },
    useRestoreFocusTarget: function() {
        return _reacttabster.useRestoreFocusTarget;
    },
    useRestoreFocusSource: function() {
        return _reacttabster.useRestoreFocusSource;
    },
    useUncontrolledFocus: function() {
        return _reacttabster.useUncontrolledFocus;
    },
    createDarkTheme: function() {
        return _reacttheme.createDarkTheme;
    },
    createHighContrastTheme: function() {
        return _reacttheme.createHighContrastTheme;
    },
    createLightTheme: function() {
        return _reacttheme.createLightTheme;
    },
    createTeamsDarkTheme: function() {
        return _reacttheme.createTeamsDarkTheme;
    },
    themeToTokensObject: function() {
        return _reacttheme.themeToTokensObject;
    },
    teamsDarkTheme: function() {
        return _reacttheme.teamsDarkTheme;
    },
    teamsHighContrastTheme: function() {
        return _reacttheme.teamsHighContrastTheme;
    },
    teamsLightTheme: function() {
        return _reacttheme.teamsLightTheme;
    },
    tokens: function() {
        return _reacttheme.tokens;
    },
    typographyStyles: function() {
        return _reacttheme.typographyStyles;
    },
    webDarkTheme: function() {
        return _reacttheme.webDarkTheme;
    },
    webLightTheme: function() {
        return _reacttheme.webLightTheme;
    },
    AnnounceProvider: function() {
        return _reactsharedcontexts.AnnounceProvider;
    },
    PortalMountNodeProvider: function() {
        return _reactsharedcontexts.PortalMountNodeProvider;
    },
    useAnnounce: function() {
        return _reactsharedcontexts.useAnnounce;
    },
    useFluent: function() {
        return _reactsharedcontexts.useFluent_unstable;
    },
    usePortalMountNode: function() {
        return _reactsharedcontexts.usePortalMountNode;
    },
    useTooltipVisibility: function() {
        return _reactsharedcontexts.useTooltipVisibility_unstable;
    },
    useThemeClassName: function() {
        return _reactsharedcontexts.useThemeClassName_unstable;
    },
    // eslint-disable-next-line deprecation/deprecation
    getNativeElementProps: function() {
        return _reactutilities.getNativeElementProps;
    },
    getIntrinsicElementProps: function() {
        return _reactutilities.getIntrinsicElementProps;
    },
    getPartitionedNativeProps: function() {
        return _reactutilities.getPartitionedNativeProps;
    },
    // eslint-disable-next-line deprecation/deprecation
    getSlots: function() {
        return _reactutilities.getSlots;
    },
    slot: function() {
        return _reactutilities.slot;
    },
    assertSlots: function() {
        return _reactutilities.assertSlots;
    },
    IdPrefixProvider: function() {
        return _reactutilities.IdPrefixProvider;
    },
    resetIdsForTests: function() {
        return _reactutilities.resetIdsForTests;
    },
    // eslint-disable-next-line deprecation/deprecation
    resolveShorthand: function() {
        return _reactutilities.resolveShorthand;
    },
    SSRProvider: function() {
        return _reactutilities.SSRProvider;
    },
    useId: function() {
        return _reactutilities.useId;
    },
    useIsomorphicLayoutEffect: function() {
        return _reactutilities.useIsomorphicLayoutEffect;
    },
    useEventCallback: function() {
        return _reactutilities.useEventCallback;
    },
    mergeCallbacks: function() {
        return _reactutilities.mergeCallbacks;
    },
    useIsSSR: function() {
        return _reactutilities.useIsSSR;
    },
    useMergedRefs: function() {
        return _reactutilities.useMergedRefs;
    },
    useScrollbarWidth: function() {
        return _reactutilities.useScrollbarWidth;
    },
    useSelection: function() {
        return _reactutilities.useSelection;
    },
    Accordion: function() {
        return _reactaccordion.Accordion;
    },
    AccordionProvider: function() {
        return _reactaccordion.AccordionProvider;
    },
    AccordionHeader: function() {
        return _reactaccordion.AccordionHeader;
    },
    AccordionItem: function() {
        return _reactaccordion.AccordionItem;
    },
    AccordionItemProvider: function() {
        return _reactaccordion.AccordionItemProvider;
    },
    AccordionPanel: function() {
        return _reactaccordion.AccordionPanel;
    },
    accordionClassNames: function() {
        return _reactaccordion.accordionClassNames;
    },
    accordionHeaderClassNames: function() {
        return _reactaccordion.accordionHeaderClassNames;
    },
    accordionItemClassNames: function() {
        return _reactaccordion.accordionItemClassNames;
    },
    accordionPanelClassNames: function() {
        return _reactaccordion.accordionPanelClassNames;
    },
    renderAccordion_unstable: function() {
        return _reactaccordion.renderAccordion_unstable;
    },
    renderAccordionHeader_unstable: function() {
        return _reactaccordion.renderAccordionHeader_unstable;
    },
    renderAccordionItem_unstable: function() {
        return _reactaccordion.renderAccordionItem_unstable;
    },
    renderAccordionPanel_unstable: function() {
        return _reactaccordion.renderAccordionPanel_unstable;
    },
    useAccordion_unstable: function() {
        return _reactaccordion.useAccordion_unstable;
    },
    useAccordionContext_unstable: function() {
        return _reactaccordion.useAccordionContext_unstable;
    },
    useAccordionContextValues_unstable: function() {
        return _reactaccordion.useAccordionContextValues_unstable;
    },
    useAccordionHeader_unstable: function() {
        return _reactaccordion.useAccordionHeader_unstable;
    },
    useAccordionHeaderContextValues_unstable: function() {
        return _reactaccordion.useAccordionHeaderContextValues_unstable;
    },
    useAccordionHeaderStyles_unstable: function() {
        return _reactaccordion.useAccordionHeaderStyles_unstable;
    },
    useAccordionItem_unstable: function() {
        return _reactaccordion.useAccordionItem_unstable;
    },
    useAccordionItemContext_unstable: function() {
        return _reactaccordion.useAccordionItemContext_unstable;
    },
    useAccordionItemContextValues_unstable: function() {
        return _reactaccordion.useAccordionItemContextValues_unstable;
    },
    useAccordionItemStyles_unstable: function() {
        return _reactaccordion.useAccordionItemStyles_unstable;
    },
    useAccordionPanel_unstable: function() {
        return _reactaccordion.useAccordionPanel_unstable;
    },
    useAccordionPanelStyles_unstable: function() {
        return _reactaccordion.useAccordionPanelStyles_unstable;
    },
    useAccordionStyles_unstable: function() {
        return _reactaccordion.useAccordionStyles_unstable;
    },
    Avatar: function() {
        return _reactavatar.Avatar;
    },
    avatarClassNames: function() {
        return _reactavatar.avatarClassNames;
    },
    renderAvatar_unstable: function() {
        return _reactavatar.renderAvatar_unstable;
    },
    useAvatar_unstable: function() {
        return _reactavatar.useAvatar_unstable;
    },
    useAvatarStyles_unstable: function() {
        return _reactavatar.useAvatarStyles_unstable;
    },
    AvatarGroup: function() {
        return _reactavatar.AvatarGroup;
    },
    avatarGroupClassNames: function() {
        return _reactavatar.avatarGroupClassNames;
    },
    AvatarGroupItem: function() {
        return _reactavatar.AvatarGroupItem;
    },
    avatarGroupItemClassNames: function() {
        return _reactavatar.avatarGroupItemClassNames;
    },
    AvatarGroupPopover: function() {
        return _reactavatar.AvatarGroupPopover;
    },
    avatarGroupPopoverClassNames: function() {
        return _reactavatar.avatarGroupPopoverClassNames;
    },
    AvatarGroupProvider: function() {
        return _reactavatar.AvatarGroupProvider;
    },
    renderAvatarGroup_unstable: function() {
        return _reactavatar.renderAvatarGroup_unstable;
    },
    useAvatarGroupContextValues: function() {
        return _reactavatar.useAvatarGroupContextValues;
    },
    useAvatarGroupStyles_unstable: function() {
        return _reactavatar.useAvatarGroupStyles_unstable;
    },
    useAvatarGroup_unstable: function() {
        return _reactavatar.useAvatarGroup_unstable;
    },
    renderAvatarGroupItem_unstable: function() {
        return _reactavatar.renderAvatarGroupItem_unstable;
    },
    useAvatarGroupItemStyles_unstable: function() {
        return _reactavatar.useAvatarGroupItemStyles_unstable;
    },
    useAvatarGroupItem_unstable: function() {
        return _reactavatar.useAvatarGroupItem_unstable;
    },
    renderAvatarGroupPopover_unstable: function() {
        return _reactavatar.renderAvatarGroupPopover_unstable;
    },
    useAvatarGroupPopoverStyles_unstable: function() {
        return _reactavatar.useAvatarGroupPopoverStyles_unstable;
    },
    useAvatarGroupPopoverContextValues_unstable: function() {
        return _reactavatar.useAvatarGroupPopoverContextValues_unstable;
    },
    useAvatarGroupPopover_unstable: function() {
        return _reactavatar.useAvatarGroupPopover_unstable;
    },
    useAvatarGroupContext_unstable: function() {
        return _reactavatar.useAvatarGroupContext_unstable;
    },
    partitionAvatarGroupItems: function() {
        return _reactavatar.partitionAvatarGroupItems;
    },
    Badge: function() {
        return _reactbadge.Badge;
    },
    CounterBadge: function() {
        return _reactbadge.CounterBadge;
    },
    PresenceBadge: function() {
        return _reactbadge.PresenceBadge;
    },
    badgeClassNames: function() {
        return _reactbadge.badgeClassNames;
    },
    counterBadgeClassNames: function() {
        return _reactbadge.counterBadgeClassNames;
    },
    presenceBadgeClassNames: function() {
        return _reactbadge.presenceBadgeClassNames;
    },
    renderBadge_unstable: function() {
        return _reactbadge.renderBadge_unstable;
    },
    useBadge_unstable: function() {
        return _reactbadge.useBadge_unstable;
    },
    useBadgeStyles_unstable: function() {
        return _reactbadge.useBadgeStyles_unstable;
    },
    useCounterBadge_unstable: function() {
        return _reactbadge.useCounterBadge_unstable;
    },
    useCounterBadgeStyles_unstable: function() {
        return _reactbadge.useCounterBadgeStyles_unstable;
    },
    usePresenceBadge_unstable: function() {
        return _reactbadge.usePresenceBadge_unstable;
    },
    usePresenceBadgeStyles_unstable: function() {
        return _reactbadge.usePresenceBadgeStyles_unstable;
    },
    presenceAwayRegular: function() {
        return _reactbadge.presenceAwayRegular;
    },
    presenceAwayFilled: function() {
        return _reactbadge.presenceAwayFilled;
    },
    presenceAvailableRegular: function() {
        return _reactbadge.presenceAvailableRegular;
    },
    presenceAvailableFilled: function() {
        return _reactbadge.presenceAvailableFilled;
    },
    presenceBlockedRegular: function() {
        return _reactbadge.presenceBlockedRegular;
    },
    presenceBusyFilled: function() {
        return _reactbadge.presenceBusyFilled;
    },
    presenceDndRegular: function() {
        return _reactbadge.presenceDndRegular;
    },
    presenceDndFilled: function() {
        return _reactbadge.presenceDndFilled;
    },
    presenceOofRegular: function() {
        return _reactbadge.presenceOofRegular;
    },
    presenceOfflineRegular: function() {
        return _reactbadge.presenceOfflineRegular;
    },
    presenceUnknownRegular: function() {
        return _reactbadge.presenceUnknownRegular;
    },
    Button: function() {
        return _reactbutton.Button;
    },
    CompoundButton: function() {
        return _reactbutton.CompoundButton;
    },
    MenuButton: function() {
        return _reactbutton.MenuButton;
    },
    SplitButton: function() {
        return _reactbutton.SplitButton;
    },
    ToggleButton: function() {
        return _reactbutton.ToggleButton;
    },
    buttonClassNames: function() {
        return _reactbutton.buttonClassNames;
    },
    compoundButtonClassNames: function() {
        return _reactbutton.compoundButtonClassNames;
    },
    menuButtonClassNames: function() {
        return _reactbutton.menuButtonClassNames;
    },
    renderButton_unstable: function() {
        return _reactbutton.renderButton_unstable;
    },
    renderCompoundButton_unstable: function() {
        return _reactbutton.renderCompoundButton_unstable;
    },
    renderMenuButton_unstable: function() {
        return _reactbutton.renderMenuButton_unstable;
    },
    renderSplitButton_unstable: function() {
        return _reactbutton.renderSplitButton_unstable;
    },
    renderToggleButton_unstable: function() {
        return _reactbutton.renderToggleButton_unstable;
    },
    splitButtonClassNames: function() {
        return _reactbutton.splitButtonClassNames;
    },
    toggleButtonClassNames: function() {
        return _reactbutton.toggleButtonClassNames;
    },
    useButton_unstable: function() {
        return _reactbutton.useButton_unstable;
    },
    useButtonStyles_unstable: function() {
        return _reactbutton.useButtonStyles_unstable;
    },
    useCompoundButton_unstable: function() {
        return _reactbutton.useCompoundButton_unstable;
    },
    useCompoundButtonStyles_unstable: function() {
        return _reactbutton.useCompoundButtonStyles_unstable;
    },
    useMenuButton_unstable: function() {
        return _reactbutton.useMenuButton_unstable;
    },
    useMenuButtonStyles_unstable: function() {
        return _reactbutton.useMenuButtonStyles_unstable;
    },
    useSplitButton_unstable: function() {
        return _reactbutton.useSplitButton_unstable;
    },
    useSplitButtonStyles_unstable: function() {
        return _reactbutton.useSplitButtonStyles_unstable;
    },
    useToggleButton_unstable: function() {
        return _reactbutton.useToggleButton_unstable;
    },
    useToggleButtonStyles_unstable: function() {
        return _reactbutton.useToggleButtonStyles_unstable;
    },
    useToggleState: function() {
        return _reactbutton.useToggleState;
    },
    Checkbox: function() {
        return _reactcheckbox.Checkbox;
    },
    checkboxClassNames: function() {
        return _reactcheckbox.checkboxClassNames;
    },
    renderCheckbox_unstable: function() {
        return _reactcheckbox.renderCheckbox_unstable;
    },
    useCheckbox_unstable: function() {
        return _reactcheckbox.useCheckbox_unstable;
    },
    useCheckboxStyles_unstable: function() {
        return _reactcheckbox.useCheckboxStyles_unstable;
    },
    Combobox: function() {
        return _reactcombobox.Combobox;
    },
    renderCombobox_unstable: function() {
        return _reactcombobox.renderCombobox_unstable;
    },
    comboboxClassNames: function() {
        return _reactcombobox.comboboxClassNames;
    },
    useComboboxStyles_unstable: function() {
        return _reactcombobox.useComboboxStyles_unstable;
    },
    useCombobox_unstable: function() {
        return _reactcombobox.useCombobox_unstable;
    },
    Dropdown: function() {
        return _reactcombobox.Dropdown;
    },
    renderDropdown_unstable: function() {
        return _reactcombobox.renderDropdown_unstable;
    },
    dropdownClassNames: function() {
        return _reactcombobox.dropdownClassNames;
    },
    useDropdownStyles_unstable: function() {
        return _reactcombobox.useDropdownStyles_unstable;
    },
    useDropdown_unstable: function() {
        return _reactcombobox.useDropdown_unstable;
    },
    Listbox: function() {
        return _reactcombobox.Listbox;
    },
    renderListbox_unstable: function() {
        return _reactcombobox.renderListbox_unstable;
    },
    listboxClassNames: function() {
        return _reactcombobox.listboxClassNames;
    },
    useListboxStyles_unstable: function() {
        return _reactcombobox.useListboxStyles_unstable;
    },
    useListbox_unstable: function() {
        return _reactcombobox.useListbox_unstable;
    },
    Option: function() {
        return _reactcombobox.Option;
    },
    renderOption_unstable: function() {
        return _reactcombobox.renderOption_unstable;
    },
    optionClassNames: function() {
        return _reactcombobox.optionClassNames;
    },
    useOptionStyles_unstable: function() {
        return _reactcombobox.useOptionStyles_unstable;
    },
    useOption_unstable: function() {
        return _reactcombobox.useOption_unstable;
    },
    OptionGroup: function() {
        return _reactcombobox.OptionGroup;
    },
    renderOptionGroup_unstable: function() {
        return _reactcombobox.renderOptionGroup_unstable;
    },
    optionGroupClassNames: function() {
        return _reactcombobox.optionGroupClassNames;
    },
    useOptionGroupStyles_unstable: function() {
        return _reactcombobox.useOptionGroupStyles_unstable;
    },
    useOptionGroup_unstable: function() {
        return _reactcombobox.useOptionGroup_unstable;
    },
    ComboboxProvider: function() {
        return _reactcombobox.ComboboxProvider;
    },
    useComboboxContextValues: function() {
        return _reactcombobox.useComboboxContextValues;
    },
    ListboxProvider: function() {
        return _reactcombobox.ListboxProvider;
    },
    useListboxContextValues: function() {
        return _reactcombobox.useListboxContextValues;
    },
    useComboboxFilter: function() {
        return _reactcombobox.useComboboxFilter;
    },
    Divider: function() {
        return _reactdivider.Divider;
    },
    dividerClassNames: function() {
        return _reactdivider.dividerClassNames;
    },
    renderDivider_unstable: function() {
        return _reactdivider.renderDivider_unstable;
    },
    useDivider_unstable: function() {
        return _reactdivider.useDivider_unstable;
    },
    useDividerStyles_unstable: function() {
        return _reactdivider.useDividerStyles_unstable;
    },
    Input: function() {
        return _reactinput.Input;
    },
    inputClassNames: function() {
        return _reactinput.inputClassNames;
    },
    renderInput_unstable: function() {
        return _reactinput.renderInput_unstable;
    },
    useInput_unstable: function() {
        return _reactinput.useInput_unstable;
    },
    useInputStyles_unstable: function() {
        return _reactinput.useInputStyles_unstable;
    },
    Image: function() {
        return _reactimage.Image;
    },
    imageClassNames: function() {
        return _reactimage.imageClassNames;
    },
    renderImage_unstable: function() {
        return _reactimage.renderImage_unstable;
    },
    useImage_unstable: function() {
        return _reactimage.useImage_unstable;
    },
    useImageStyles_unstable: function() {
        return _reactimage.useImageStyles_unstable;
    },
    Label: function() {
        return _reactlabel.Label;
    },
    labelClassNames: function() {
        return _reactlabel.labelClassNames;
    },
    renderLabel_unstable: function() {
        return _reactlabel.renderLabel_unstable;
    },
    useLabel_unstable: function() {
        return _reactlabel.useLabel_unstable;
    },
    useLabelStyles_unstable: function() {
        return _reactlabel.useLabelStyles_unstable;
    },
    Link: function() {
        return _reactlink.Link;
    },
    linkClassNames: function() {
        return _reactlink.linkClassNames;
    },
    renderLink_unstable: function() {
        return _reactlink.renderLink_unstable;
    },
    useLink_unstable: function() {
        return _reactlink.useLink_unstable;
    },
    useLinkState_unstable: function() {
        return _reactlink.useLinkState_unstable;
    },
    useLinkStyles_unstable: function() {
        return _reactlink.useLinkStyles_unstable;
    },
    Menu: function() {
        return _reactmenu.Menu;
    },
    MenuDivider: function() {
        return _reactmenu.MenuDivider;
    },
    MenuGroup: function() {
        return _reactmenu.MenuGroup;
    },
    MenuGroupContextProvider: function() {
        return _reactmenu.MenuGroupContextProvider;
    },
    MenuGroupHeader: function() {
        return _reactmenu.MenuGroupHeader;
    },
    MenuItem: function() {
        return _reactmenu.MenuItem;
    },
    MenuItemLink: function() {
        return _reactmenu.MenuItemLink;
    },
    MenuItemCheckbox: function() {
        return _reactmenu.MenuItemCheckbox;
    },
    MenuItemRadio: function() {
        return _reactmenu.MenuItemRadio;
    },
    MenuList: function() {
        return _reactmenu.MenuList;
    },
    MenuListProvider: function() {
        return _reactmenu.MenuListProvider;
    },
    MenuPopover: function() {
        return _reactmenu.MenuPopover;
    },
    MenuProvider: function() {
        return _reactmenu.MenuProvider;
    },
    MenuSplitGroup: function() {
        return _reactmenu.MenuSplitGroup;
    },
    MenuTrigger: function() {
        return _reactmenu.MenuTrigger;
    },
    MenuTriggerContextProvider: function() {
        return _reactmenu.MenuTriggerContextProvider;
    },
    menuDividerClassNames: function() {
        return _reactmenu.menuDividerClassNames;
    },
    menuGroupClassNames: function() {
        return _reactmenu.menuGroupClassNames;
    },
    menuGroupHeaderClassNames: function() {
        return _reactmenu.menuGroupHeaderClassNames;
    },
    menuItemCheckboxClassNames: function() {
        return _reactmenu.menuItemCheckboxClassNames;
    },
    menuItemClassNames: function() {
        return _reactmenu.menuItemClassNames;
    },
    menuItemLinkClassNames: function() {
        return _reactmenu.menuItemLinkClassNames;
    },
    menuItemRadioClassNames: function() {
        return _reactmenu.menuItemRadioClassNames;
    },
    menuListClassNames: function() {
        return _reactmenu.menuListClassNames;
    },
    menuPopoverClassNames: function() {
        return _reactmenu.menuPopoverClassNames;
    },
    menuSplitGroupClassNames: function() {
        return _reactmenu.menuSplitGroupClassNames;
    },
    renderMenu_unstable: function() {
        return _reactmenu.renderMenu_unstable;
    },
    renderMenuDivider_unstable: function() {
        return _reactmenu.renderMenuDivider_unstable;
    },
    renderMenuGroup_unstable: function() {
        return _reactmenu.renderMenuGroup_unstable;
    },
    renderMenuGroupHeader_unstable: function() {
        return _reactmenu.renderMenuGroupHeader_unstable;
    },
    renderMenuItem_unstable: function() {
        return _reactmenu.renderMenuItem_unstable;
    },
    renderMenuItemLink_unstable: function() {
        return _reactmenu.renderMenuItemLink_unstable;
    },
    renderMenuItemCheckbox_unstable: function() {
        return _reactmenu.renderMenuItemCheckbox_unstable;
    },
    renderMenuItemRadio_unstable: function() {
        return _reactmenu.renderMenuItemRadio_unstable;
    },
    renderMenuList_unstable: function() {
        return _reactmenu.renderMenuList_unstable;
    },
    renderMenuPopover_unstable: function() {
        return _reactmenu.renderMenuPopover_unstable;
    },
    renderMenuSplitGroup_unstable: function() {
        return _reactmenu.renderMenuSplitGroup_unstable;
    },
    renderMenuTrigger_unstable: function() {
        return _reactmenu.renderMenuTrigger_unstable;
    },
    useCheckmarkStyles_unstable: function() {
        return _reactmenu.useCheckmarkStyles_unstable;
    },
    useMenu_unstable: function() {
        return _reactmenu.useMenu_unstable;
    },
    useMenuContext_unstable: function() {
        return _reactmenu.useMenuContext_unstable;
    },
    useMenuContextValues_unstable: function() {
        return _reactmenu.useMenuContextValues_unstable;
    },
    useMenuDivider_unstable: function() {
        return _reactmenu.useMenuDivider_unstable;
    },
    useMenuDividerStyles_unstable: function() {
        return _reactmenu.useMenuDividerStyles_unstable;
    },
    useMenuGroup_unstable: function() {
        return _reactmenu.useMenuGroup_unstable;
    },
    useMenuGroupContext_unstable: function() {
        return _reactmenu.useMenuGroupContext_unstable;
    },
    useMenuGroupContextValues_unstable: function() {
        return _reactmenu.useMenuGroupContextValues_unstable;
    },
    useMenuGroupHeader_unstable: function() {
        return _reactmenu.useMenuGroupHeader_unstable;
    },
    useMenuGroupHeaderStyles_unstable: function() {
        return _reactmenu.useMenuGroupHeaderStyles_unstable;
    },
    useMenuGroupStyles_unstable: function() {
        return _reactmenu.useMenuGroupStyles_unstable;
    },
    useMenuItem_unstable: function() {
        return _reactmenu.useMenuItem_unstable;
    },
    useMenuItemLink_unstable: function() {
        return _reactmenu.useMenuItemLink_unstable;
    },
    useMenuItemCheckbox_unstable: function() {
        return _reactmenu.useMenuItemCheckbox_unstable;
    },
    useMenuItemCheckboxStyles_unstable: function() {
        return _reactmenu.useMenuItemCheckboxStyles_unstable;
    },
    useMenuItemRadio_unstable: function() {
        return _reactmenu.useMenuItemRadio_unstable;
    },
    useMenuItemRadioStyles_unstable: function() {
        return _reactmenu.useMenuItemRadioStyles_unstable;
    },
    useMenuItemStyles_unstable: function() {
        return _reactmenu.useMenuItemStyles_unstable;
    },
    useMenuItemLinkStyles_unstable: function() {
        return _reactmenu.useMenuItemLinkStyles_unstable;
    },
    useMenuList_unstable: function() {
        return _reactmenu.useMenuList_unstable;
    },
    useMenuListContext_unstable: function() {
        return _reactmenu.useMenuListContext_unstable;
    },
    useMenuListContextValues_unstable: function() {
        return _reactmenu.useMenuListContextValues_unstable;
    },
    useMenuListStyles_unstable: function() {
        return _reactmenu.useMenuListStyles_unstable;
    },
    useMenuPopover_unstable: function() {
        return _reactmenu.useMenuPopover_unstable;
    },
    useMenuPopoverStyles_unstable: function() {
        return _reactmenu.useMenuPopoverStyles_unstable;
    },
    useMenuSplitGroup_unstable: function() {
        return _reactmenu.useMenuSplitGroup_unstable;
    },
    useMenuSplitGroupStyles_unstable: function() {
        return _reactmenu.useMenuSplitGroupStyles_unstable;
    },
    useMenuTrigger_unstable: function() {
        return _reactmenu.useMenuTrigger_unstable;
    },
    useMenuTriggerContext_unstable: function() {
        return _reactmenu.useMenuTriggerContext_unstable;
    },
    Persona: function() {
        return _reactpersona.Persona;
    },
    personaClassNames: function() {
        return _reactpersona.personaClassNames;
    },
    renderPersona_unstable: function() {
        return _reactpersona.renderPersona_unstable;
    },
    usePersonaStyles_unstable: function() {
        return _reactpersona.usePersonaStyles_unstable;
    },
    usePersona_unstable: function() {
        return _reactpersona.usePersona_unstable;
    },
    Popover: function() {
        return _reactpopover.Popover;
    },
    PopoverSurface: function() {
        return _reactpopover.PopoverSurface;
    },
    PopoverProvider: function() {
        return _reactpopover.PopoverProvider;
    },
    PopoverTrigger: function() {
        return _reactpopover.PopoverTrigger;
    },
    arrowHeights: function() {
        return _reactpopover.arrowHeights;
    },
    popoverSurfaceClassNames: function() {
        return _reactpopover.popoverSurfaceClassNames;
    },
    renderPopover_unstable: function() {
        return _reactpopover.renderPopover_unstable;
    },
    renderPopoverSurface_unstable: function() {
        return _reactpopover.renderPopoverSurface_unstable;
    },
    renderPopoverTrigger_unstable: function() {
        return _reactpopover.renderPopoverTrigger_unstable;
    },
    usePopover_unstable: function() {
        return _reactpopover.usePopover_unstable;
    },
    usePopoverContext_unstable: function() {
        return _reactpopover.usePopoverContext_unstable;
    },
    usePopoverSurface_unstable: function() {
        return _reactpopover.usePopoverSurface_unstable;
    },
    usePopoverSurfaceStyles_unstable: function() {
        return _reactpopover.usePopoverSurfaceStyles_unstable;
    },
    usePopoverTrigger_unstable: function() {
        return _reactpopover.usePopoverTrigger_unstable;
    },
    Portal: function() {
        return _reactportal.Portal;
    },
    usePortal_unstable: function() {
        return _reactportal.usePortal_unstable;
    },
    renderPortal_unstable: function() {
        return _reactportal.renderPortal_unstable;
    },
    toMountNodeProps: function() {
        return _reactportal.toMountNodeProps;
    },
    Radio: function() {
        return _reactradio.Radio;
    },
    radioClassNames: function() {
        return _reactradio.radioClassNames;
    },
    RadioGroup: function() {
        return _reactradio.RadioGroup;
    },
    RadioGroupProvider: function() {
        return _reactradio.RadioGroupProvider;
    },
    radioGroupClassNames: function() {
        return _reactradio.radioGroupClassNames;
    },
    renderRadio_unstable: function() {
        return _reactradio.renderRadio_unstable;
    },
    renderRadioGroup_unstable: function() {
        return _reactradio.renderRadioGroup_unstable;
    },
    useRadio_unstable: function() {
        return _reactradio.useRadio_unstable;
    },
    useRadioGroupContext_unstable: function() {
        return _reactradio.useRadioGroupContext_unstable;
    },
    useRadioGroupContextValue_unstable: function() {
        return _reactradio.useRadioGroupContextValue_unstable;
    },
    useRadioGroupContextValues: function() {
        return _reactradio.useRadioGroupContextValues;
    },
    useRadioGroup_unstable: function() {
        return _reactradio.useRadioGroup_unstable;
    },
    useRadioGroupStyles_unstable: function() {
        return _reactradio.useRadioGroupStyles_unstable;
    },
    useRadioStyles_unstable: function() {
        return _reactradio.useRadioStyles_unstable;
    },
    Select: function() {
        return _reactselect.Select;
    },
    renderSelect_unstable: function() {
        return _reactselect.renderSelect_unstable;
    },
    selectClassNames: function() {
        return _reactselect.selectClassNames;
    },
    useSelectStyles_unstable: function() {
        return _reactselect.useSelectStyles_unstable;
    },
    useSelect_unstable: function() {
        return _reactselect.useSelect_unstable;
    },
    Skeleton: function() {
        return _reactskeleton.Skeleton;
    },
    renderSkeleton_unstable: function() {
        return _reactskeleton.renderSkeleton_unstable;
    },
    skeletonClassNames: function() {
        return _reactskeleton.skeletonClassNames;
    },
    useSkeletonStyles_unstable: function() {
        return _reactskeleton.useSkeletonStyles_unstable;
    },
    useSkeleton_unstable: function() {
        return _reactskeleton.useSkeleton_unstable;
    },
    SkeletonItem: function() {
        return _reactskeleton.SkeletonItem;
    },
    renderSkeletonItem_unstable: function() {
        return _reactskeleton.renderSkeletonItem_unstable;
    },
    skeletonItemClassNames: function() {
        return _reactskeleton.skeletonItemClassNames;
    },
    useSkeletonItemStyles_unstable: function() {
        return _reactskeleton.useSkeletonItemStyles_unstable;
    },
    useSkeletonItem_unstable: function() {
        return _reactskeleton.useSkeletonItem_unstable;
    },
    SkeletonContextProvider: function() {
        return _reactskeleton.SkeletonContextProvider;
    },
    useSkeletonContext: function() {
        return _reactskeleton.useSkeletonContext;
    },
    Slider: function() {
        return _reactslider.Slider;
    },
    sliderClassNames: function() {
        return _reactslider.sliderClassNames;
    },
    sliderCSSVars: function() {
        return _reactslider.sliderCSSVars;
    },
    useSliderState_unstable: function() {
        return _reactslider.useSliderState_unstable;
    },
    useSliderStyles_unstable: function() {
        return _reactslider.useSliderStyles_unstable;
    },
    useSlider_unstable: function() {
        return _reactslider.useSlider_unstable;
    },
    renderSlider_unstable: function() {
        return _reactslider.renderSlider_unstable;
    },
    SpinButton: function() {
        return _reactspinbutton.SpinButton;
    },
    renderSpinButton_unstable: function() {
        return _reactspinbutton.renderSpinButton_unstable;
    },
    spinButtonClassNames: function() {
        return _reactspinbutton.spinButtonClassNames;
    },
    useSpinButtonStyles_unstable: function() {
        return _reactspinbutton.useSpinButtonStyles_unstable;
    },
    useSpinButton_unstable: function() {
        return _reactspinbutton.useSpinButton_unstable;
    },
    Spinner: function() {
        return _reactspinner.Spinner;
    },
    spinnerClassNames: function() {
        return _reactspinner.spinnerClassNames;
    },
    renderSpinner_unstable: function() {
        return _reactspinner.renderSpinner_unstable;
    },
    useSpinner_unstable: function() {
        return _reactspinner.useSpinner_unstable;
    },
    useSpinnerStyles_unstable: function() {
        return _reactspinner.useSpinnerStyles_unstable;
    },
    Switch: function() {
        return _reactswitch.Switch;
    },
    switchClassNames: function() {
        return _reactswitch.switchClassNames;
    },
    renderSwitch_unstable: function() {
        return _reactswitch.renderSwitch_unstable;
    },
    useSwitch_unstable: function() {
        return _reactswitch.useSwitch_unstable;
    },
    useSwitchStyles_unstable: function() {
        return _reactswitch.useSwitchStyles_unstable;
    },
    renderTab_unstable: function() {
        return _reacttabs.renderTab_unstable;
    },
    Tab: function() {
        return _reacttabs.Tab;
    },
    tabClassNames: function() {
        return _reacttabs.tabClassNames;
    },
    useTabStyles_unstable: function() {
        return _reacttabs.useTabStyles_unstable;
    },
    useTab_unstable: function() {
        return _reacttabs.useTab_unstable;
    },
    renderTabList_unstable: function() {
        return _reacttabs.renderTabList_unstable;
    },
    TabList: function() {
        return _reacttabs.TabList;
    },
    tabListClassNames: function() {
        return _reacttabs.tabListClassNames;
    },
    TabListProvider: function() {
        return _reacttabs.TabListProvider;
    },
    useTabListContext_unstable: function() {
        return _reacttabs.useTabListContext_unstable;
    },
    useTabListContextValues_unstable: function() {
        return _reacttabs.useTabListContextValues_unstable;
    },
    useTabListStyles_unstable: function() {
        return _reacttabs.useTabListStyles_unstable;
    },
    useTabList_unstable: function() {
        return _reacttabs.useTabList_unstable;
    },
    Body1: function() {
        return _reacttext.Body1;
    },
    Body1Strong: function() {
        return _reacttext.Body1Strong;
    },
    Body1Stronger: function() {
        return _reacttext.Body1Stronger;
    },
    Body2: function() {
        return _reacttext.Body2;
    },
    Caption1: function() {
        return _reacttext.Caption1;
    },
    Caption1Strong: function() {
        return _reacttext.Caption1Strong;
    },
    Caption1Stronger: function() {
        return _reacttext.Caption1Stronger;
    },
    Caption2: function() {
        return _reacttext.Caption2;
    },
    Caption2Strong: function() {
        return _reacttext.Caption2Strong;
    },
    Display: function() {
        return _reacttext.Display;
    },
    LargeTitle: function() {
        return _reacttext.LargeTitle;
    },
    Subtitle1: function() {
        return _reacttext.Subtitle1;
    },
    Subtitle2: function() {
        return _reacttext.Subtitle2;
    },
    Subtitle2Stronger: function() {
        return _reacttext.Subtitle2Stronger;
    },
    Text: function() {
        return _reacttext.Text;
    },
    Title1: function() {
        return _reacttext.Title1;
    },
    Title2: function() {
        return _reacttext.Title2;
    },
    Title3: function() {
        return _reacttext.Title3;
    },
    body1ClassNames: function() {
        return _reacttext.body1ClassNames;
    },
    body1StrongClassNames: function() {
        return _reacttext.body1StrongClassNames;
    },
    body1StrongerClassNames: function() {
        return _reacttext.body1StrongerClassNames;
    },
    body2ClassNames: function() {
        return _reacttext.body2ClassNames;
    },
    caption1ClassNames: function() {
        return _reacttext.caption1ClassNames;
    },
    caption1StrongClassNames: function() {
        return _reacttext.caption1StrongClassNames;
    },
    caption1StrongerClassNames: function() {
        return _reacttext.caption1StrongerClassNames;
    },
    caption2ClassNames: function() {
        return _reacttext.caption2ClassNames;
    },
    caption2StrongClassNames: function() {
        return _reacttext.caption2StrongClassNames;
    },
    displayClassNames: function() {
        return _reacttext.displayClassNames;
    },
    largeTitleClassNames: function() {
        return _reacttext.largeTitleClassNames;
    },
    subtitle1ClassNames: function() {
        return _reacttext.subtitle1ClassNames;
    },
    subtitle2ClassNames: function() {
        return _reacttext.subtitle2ClassNames;
    },
    subtitle2StrongerClassNames: function() {
        return _reacttext.subtitle2StrongerClassNames;
    },
    textClassNames: function() {
        return _reacttext.textClassNames;
    },
    title1ClassNames: function() {
        return _reacttext.title1ClassNames;
    },
    title2ClassNames: function() {
        return _reacttext.title2ClassNames;
    },
    title3ClassNames: function() {
        return _reacttext.title3ClassNames;
    },
    renderText_unstable: function() {
        return _reacttext.renderText_unstable;
    },
    useText_unstable: function() {
        return _reacttext.useText_unstable;
    },
    useTextStyles_unstable: function() {
        return _reacttext.useTextStyles_unstable;
    },
    Textarea: function() {
        return _reacttextarea.Textarea;
    },
    textareaClassNames: function() {
        return _reacttextarea.textareaClassNames;
    },
    renderTextarea_unstable: function() {
        return _reacttextarea.renderTextarea_unstable;
    },
    useTextarea_unstable: function() {
        return _reacttextarea.useTextarea_unstable;
    },
    useTextareaStyles_unstable: function() {
        return _reacttextarea.useTextareaStyles_unstable;
    },
    Tooltip: function() {
        return _reacttooltip.Tooltip;
    },
    renderTooltip_unstable: function() {
        return _reacttooltip.renderTooltip_unstable;
    },
    tooltipClassNames: function() {
        return _reacttooltip.tooltipClassNames;
    },
    useTooltip_unstable: function() {
        return _reacttooltip.useTooltip_unstable;
    },
    useTooltipStyles_unstable: function() {
        return _reacttooltip.useTooltipStyles_unstable;
    },
    resolvePositioningShorthand: function() {
        return _reactpositioning.resolvePositioningShorthand;
    },
    Dialog: function() {
        return _reactdialog.Dialog;
    },
    useDialog_unstable: function() {
        return _reactdialog.useDialog_unstable;
    },
    renderDialog_unstable: function() {
        return _reactdialog.renderDialog_unstable;
    },
    DialogTitle: function() {
        return _reactdialog.DialogTitle;
    },
    dialogTitleClassNames: function() {
        return _reactdialog.dialogTitleClassNames;
    },
    useDialogTitle_unstable: function() {
        return _reactdialog.useDialogTitle_unstable;
    },
    useDialogTitleStyles_unstable: function() {
        return _reactdialog.useDialogTitleStyles_unstable;
    },
    renderDialogTitle_unstable: function() {
        return _reactdialog.renderDialogTitle_unstable;
    },
    DialogTrigger: function() {
        return _reactdialog.DialogTrigger;
    },
    useDialogTrigger_unstable: function() {
        return _reactdialog.useDialogTrigger_unstable;
    },
    renderDialogTrigger_unstable: function() {
        return _reactdialog.renderDialogTrigger_unstable;
    },
    DialogBody: function() {
        return _reactdialog.DialogBody;
    },
    dialogBodyClassNames: function() {
        return _reactdialog.dialogBodyClassNames;
    },
    useDialogBody_unstable: function() {
        return _reactdialog.useDialogBody_unstable;
    },
    useDialogBodyStyles_unstable: function() {
        return _reactdialog.useDialogBodyStyles_unstable;
    },
    renderDialogBody_unstable: function() {
        return _reactdialog.renderDialogBody_unstable;
    },
    DialogActions: function() {
        return _reactdialog.DialogActions;
    },
    dialogActionsClassNames: function() {
        return _reactdialog.dialogActionsClassNames;
    },
    useDialogActions_unstable: function() {
        return _reactdialog.useDialogActions_unstable;
    },
    useDialogActionsStyles_unstable: function() {
        return _reactdialog.useDialogActionsStyles_unstable;
    },
    renderDialogActions_unstable: function() {
        return _reactdialog.renderDialogActions_unstable;
    },
    DialogSurface: function() {
        return _reactdialog.DialogSurface;
    },
    dialogSurfaceClassNames: function() {
        return _reactdialog.dialogSurfaceClassNames;
    },
    useDialogSurface_unstable: function() {
        return _reactdialog.useDialogSurface_unstable;
    },
    useDialogSurfaceStyles_unstable: function() {
        return _reactdialog.useDialogSurfaceStyles_unstable;
    },
    renderDialogSurface_unstable: function() {
        return _reactdialog.renderDialogSurface_unstable;
    },
    DialogContent: function() {
        return _reactdialog.DialogContent;
    },
    dialogContentClassNames: function() {
        return _reactdialog.dialogContentClassNames;
    },
    useDialogContentStyles_unstable: function() {
        return _reactdialog.useDialogContentStyles_unstable;
    },
    useDialogContent_unstable: function() {
        return _reactdialog.useDialogContent_unstable;
    },
    renderDialogContent_unstable: function() {
        return _reactdialog.renderDialogContent_unstable;
    },
    useDialogContext_unstable: function() {
        return _reactdialog.useDialogContext_unstable;
    },
    useDialogSurfaceContext_unstable: function() {
        return _reactdialog.useDialogSurfaceContext_unstable;
    },
    useDialogSurfaceContextValues_unstable: function() {
        return _reactdialog.useDialogSurfaceContextValues_unstable;
    },
    ProgressBar: function() {
        return _reactprogress.ProgressBar;
    },
    progressBarClassNames: function() {
        return _reactprogress.progressBarClassNames;
    },
    renderProgressBar_unstable: function() {
        return _reactprogress.renderProgressBar_unstable;
    },
    useProgressBarStyles_unstable: function() {
        return _reactprogress.useProgressBarStyles_unstable;
    },
    useProgressBar_unstable: function() {
        return _reactprogress.useProgressBar_unstable;
    },
    Overflow: function() {
        return _reactoverflow.Overflow;
    },
    OverflowItem: function() {
        return _reactoverflow.OverflowItem;
    },
    OverflowDivider: function() {
        return _reactoverflow.OverflowDivider;
    },
    useIsOverflowGroupVisible: function() {
        return _reactoverflow.useIsOverflowGroupVisible;
    },
    useIsOverflowItemVisible: function() {
        return _reactoverflow.useIsOverflowItemVisible;
    },
    useOverflowCount: function() {
        return _reactoverflow.useOverflowCount;
    },
    useOverflowMenu: function() {
        return _reactoverflow.useOverflowMenu;
    },
    DATA_OVERFLOWING: function() {
        return _reactoverflow.DATA_OVERFLOWING;
    },
    DATA_OVERFLOW_MENU: function() {
        return _reactoverflow.DATA_OVERFLOW_MENU;
    },
    DATA_OVERFLOW_ITEM: function() {
        return _reactoverflow.DATA_OVERFLOW_ITEM;
    },
    DATA_OVERFLOW_DIVIDER: function() {
        return _reactoverflow.DATA_OVERFLOW_DIVIDER;
    },
    useOverflowVisibility: function() {
        return _reactoverflow.useOverflowVisibility;
    },
    Toolbar: function() {
        return _reacttoolbar.Toolbar;
    },
    ToolbarButton: function() {
        return _reacttoolbar.ToolbarButton;
    },
    useToolbarButtonStyles_unstable: function() {
        return _reacttoolbar.useToolbarButtonStyles_unstable;
    },
    useToolbarButton_unstable: function() {
        return _reacttoolbar.useToolbarButton_unstable;
    },
    ToolbarRadioButton: function() {
        return _reacttoolbar.ToolbarRadioButton;
    },
    useToolbarRadioButton_unstable: function() {
        return _reacttoolbar.useToolbarRadioButton_unstable;
    },
    useToolbarRadioButtonStyles_unstable: function() {
        return _reacttoolbar.useToolbarRadioButtonStyles_unstable;
    },
    ToolbarDivider: function() {
        return _reacttoolbar.ToolbarDivider;
    },
    useToolbarDivider_unstable: function() {
        return _reacttoolbar.useToolbarDivider_unstable;
    },
    ToolbarGroup: function() {
        return _reacttoolbar.ToolbarGroup;
    },
    useToolbarGroupStyles_unstable: function() {
        return _reacttoolbar.useToolbarGroupStyles_unstable;
    },
    useToolbarGroup_unstable: function() {
        return _reacttoolbar.useToolbarGroup_unstable;
    },
    renderToolbarGroup_unstable: function() {
        return _reacttoolbar.renderToolbarGroup_unstable;
    },
    toolbarGroupClassNames: function() {
        return _reacttoolbar.toolbarGroupClassNames;
    },
    ToolbarToggleButton: function() {
        return _reacttoolbar.ToolbarToggleButton;
    },
    useToolbarToggleButtonStyles_unstable: function() {
        return _reacttoolbar.useToolbarToggleButtonStyles_unstable;
    },
    useToolbarToggleButton_unstable: function() {
        return _reacttoolbar.useToolbarToggleButton_unstable;
    },
    renderToolbar_unstable: function() {
        return _reacttoolbar.renderToolbar_unstable;
    },
    toolbarClassNames: function() {
        return _reacttoolbar.toolbarClassNames;
    },
    useToolbar_unstable: function() {
        return _reacttoolbar.useToolbar_unstable;
    },
    useToolbarDividerStyles_unstable: function() {
        return _reacttoolbar.useToolbarDividerStyles_unstable;
    },
    useToolbarStyles_unstable: function() {
        return _reacttoolbar.useToolbarStyles_unstable;
    },
    ToolbarRadioGroup: function() {
        return _reacttoolbar.ToolbarRadioGroup;
    },
    TableCell: function() {
        return _reacttable.TableCell;
    },
    tableCellClassNames: function() {
        return _reacttable.tableCellClassNames;
    },
    tableCellClassName: function() {
        return _reacttable.tableCellClassName;
    },
    useTableCellStyles_unstable: function() {
        return _reacttable.useTableCellStyles_unstable;
    },
    useTableCell_unstable: function() {
        return _reacttable.useTableCell_unstable;
    },
    renderTableCell_unstable: function() {
        return _reacttable.renderTableCell_unstable;
    },
    TableRow: function() {
        return _reacttable.TableRow;
    },
    tableRowClassNames: function() {
        return _reacttable.tableRowClassNames;
    },
    tableRowClassName: function() {
        return _reacttable.tableRowClassName;
    },
    useTableRowStyles_unstable: function() {
        return _reacttable.useTableRowStyles_unstable;
    },
    useTableRow_unstable: function() {
        return _reacttable.useTableRow_unstable;
    },
    renderTableRow_unstable: function() {
        return _reacttable.renderTableRow_unstable;
    },
    TableBody: function() {
        return _reacttable.TableBody;
    },
    tableBodyClassName: function() {
        return _reacttable.tableBodyClassName;
    },
    tableBodyClassNames: function() {
        return _reacttable.tableBodyClassNames;
    },
    useTableBodyStyles_unstable: function() {
        return _reacttable.useTableBodyStyles_unstable;
    },
    useTableBody_unstable: function() {
        return _reacttable.useTableBody_unstable;
    },
    renderTableBody_unstable: function() {
        return _reacttable.renderTableBody_unstable;
    },
    Table: function() {
        return _reacttable.Table;
    },
    tableClassName: function() {
        return _reacttable.tableClassName;
    },
    tableClassNames: function() {
        return _reacttable.tableClassNames;
    },
    useTableStyles_unstable: function() {
        return _reacttable.useTableStyles_unstable;
    },
    useTable_unstable: function() {
        return _reacttable.useTable_unstable;
    },
    renderTable_unstable: function() {
        return _reacttable.renderTable_unstable;
    },
    TableHeader: function() {
        return _reacttable.TableHeader;
    },
    tableHeaderClassNames: function() {
        return _reacttable.tableHeaderClassNames;
    },
    tableHeaderClassName: function() {
        return _reacttable.tableHeaderClassName;
    },
    useTableHeaderStyles_unstable: function() {
        return _reacttable.useTableHeaderStyles_unstable;
    },
    useTableHeader_unstable: function() {
        return _reacttable.useTableHeader_unstable;
    },
    renderTableHeader_unstable: function() {
        return _reacttable.renderTableHeader_unstable;
    },
    TableHeaderCell: function() {
        return _reacttable.TableHeaderCell;
    },
    tableHeaderCellClassName: function() {
        return _reacttable.tableHeaderCellClassName;
    },
    tableHeaderCellClassNames: function() {
        return _reacttable.tableHeaderCellClassNames;
    },
    useTableHeaderCellStyles_unstable: function() {
        return _reacttable.useTableHeaderCellStyles_unstable;
    },
    useTableHeaderCell_unstable: function() {
        return _reacttable.useTableHeaderCell_unstable;
    },
    renderTableHeaderCell_unstable: function() {
        return _reacttable.renderTableHeaderCell_unstable;
    },
    TableResizeHandle: function() {
        return _reacttable.TableResizeHandle;
    },
    tableResizeHandleClassNames: function() {
        return _reacttable.tableResizeHandleClassNames;
    },
    useTableResizeHandleStyles_unstable: function() {
        return _reacttable.useTableResizeHandleStyles_unstable;
    },
    useTableResizeHandle_unstable: function() {
        return _reacttable.useTableResizeHandle_unstable;
    },
    renderTableResizeHandle_unstable: function() {
        return _reacttable.renderTableResizeHandle_unstable;
    },
    TableContextProvider: function() {
        return _reacttable.TableContextProvider;
    },
    useTableContext: function() {
        return _reacttable.useTableContext;
    },
    TableSelectionCell: function() {
        return _reacttable.TableSelectionCell;
    },
    useTableSelectionCellStyles_unstable: function() {
        return _reacttable.useTableSelectionCellStyles_unstable;
    },
    useTableSelectionCell_unstable: function() {
        return _reacttable.useTableSelectionCell_unstable;
    },
    renderTableSelectionCell_unstable: function() {
        return _reacttable.renderTableSelectionCell_unstable;
    },
    tableSelectionCellClassNames: function() {
        return _reacttable.tableSelectionCellClassNames;
    },
    TableCellActions: function() {
        return _reacttable.TableCellActions;
    },
    useTableCellActionsStyles_unstable: function() {
        return _reacttable.useTableCellActionsStyles_unstable;
    },
    useTableCellActions_unstable: function() {
        return _reacttable.useTableCellActions_unstable;
    },
    renderTableCellActions_unstable: function() {
        return _reacttable.renderTableCellActions_unstable;
    },
    tableCellActionsClassNames: function() {
        return _reacttable.tableCellActionsClassNames;
    },
    TableCellLayout: function() {
        return _reacttable.TableCellLayout;
    },
    useTableCellLayout_unstable: function() {
        return _reacttable.useTableCellLayout_unstable;
    },
    useTableCellLayoutStyles_unstable: function() {
        return _reacttable.useTableCellLayoutStyles_unstable;
    },
    renderTableCellLayout_unstable: function() {
        return _reacttable.renderTableCellLayout_unstable;
    },
    tableCellLayoutClassNames: function() {
        return _reacttable.tableCellLayoutClassNames;
    },
    useTableFeatures: function() {
        return _reacttable.useTableFeatures;
    },
    useTableSelection: function() {
        return _reacttable.useTableSelection;
    },
    useTableSort: function() {
        return _reacttable.useTableSort;
    },
    useTableCompositeNavigation: function() {
        return _reacttable.useTableCompositeNavigation;
    },
    createTableColumn: function() {
        return _reacttable.createTableColumn;
    },
    DataGridCell: function() {
        return _reacttable.DataGridCell;
    },
    dataGridCellClassNames: function() {
        return _reacttable.dataGridCellClassNames;
    },
    useDataGridCellStyles_unstable: function() {
        return _reacttable.useDataGridCellStyles_unstable;
    },
    useDataGridCell_unstable: function() {
        return _reacttable.useDataGridCell_unstable;
    },
    renderDataGridCell_unstable: function() {
        return _reacttable.renderDataGridCell_unstable;
    },
    DataGridRow: function() {
        return _reacttable.DataGridRow;
    },
    dataGridRowClassNames: function() {
        return _reacttable.dataGridRowClassNames;
    },
    useDataGridRowStyles_unstable: function() {
        return _reacttable.useDataGridRowStyles_unstable;
    },
    useDataGridRow_unstable: function() {
        return _reacttable.useDataGridRow_unstable;
    },
    renderDataGridRow_unstable: function() {
        return _reacttable.renderDataGridRow_unstable;
    },
    DataGridBody: function() {
        return _reacttable.DataGridBody;
    },
    dataGridBodyClassNames: function() {
        return _reacttable.dataGridBodyClassNames;
    },
    useDataGridBodyStyles_unstable: function() {
        return _reacttable.useDataGridBodyStyles_unstable;
    },
    useDataGridBody_unstable: function() {
        return _reacttable.useDataGridBody_unstable;
    },
    renderDataGridBody_unstable: function() {
        return _reacttable.renderDataGridBody_unstable;
    },
    DataGrid: function() {
        return _reacttable.DataGrid;
    },
    DataGridContextProvider: function() {
        return _reacttable.DataGridContextProvider;
    },
    dataGridClassNames: function() {
        return _reacttable.dataGridClassNames;
    },
    useDataGridStyles_unstable: function() {
        return _reacttable.useDataGridStyles_unstable;
    },
    useDataGrid_unstable: function() {
        return _reacttable.useDataGrid_unstable;
    },
    useDataGridContext_unstable: function() {
        return _reacttable.useDataGridContext_unstable;
    },
    renderDataGrid_unstable: function() {
        return _reacttable.renderDataGrid_unstable;
    },
    useDataGridContextValues_unstable: function() {
        return _reacttable.useDataGridContextValues_unstable;
    },
    DataGridHeader: function() {
        return _reacttable.DataGridHeader;
    },
    dataGridHeaderClassNames: function() {
        return _reacttable.dataGridHeaderClassNames;
    },
    useDataGridHeaderStyles_unstable: function() {
        return _reacttable.useDataGridHeaderStyles_unstable;
    },
    useDataGridHeader_unstable: function() {
        return _reacttable.useDataGridHeader_unstable;
    },
    renderDataGridHeader_unstable: function() {
        return _reacttable.renderDataGridHeader_unstable;
    },
    DataGridHeaderCell: function() {
        return _reacttable.DataGridHeaderCell;
    },
    dataGridHeaderCellClassNames: function() {
        return _reacttable.dataGridHeaderCellClassNames;
    },
    useDataGridHeaderCellStyles_unstable: function() {
        return _reacttable.useDataGridHeaderCellStyles_unstable;
    },
    useDataGridHeaderCell_unstable: function() {
        return _reacttable.useDataGridHeaderCell_unstable;
    },
    renderDataGridHeaderCell_unstable: function() {
        return _reacttable.renderDataGridHeaderCell_unstable;
    },
    DataGridSelectionCell: function() {
        return _reacttable.DataGridSelectionCell;
    },
    useDataGridSelectionCellStyles_unstable: function() {
        return _reacttable.useDataGridSelectionCellStyles_unstable;
    },
    useDataGridSelectionCell_unstable: function() {
        return _reacttable.useDataGridSelectionCell_unstable;
    },
    renderDataGridSelectionCell_unstable: function() {
        return _reacttable.renderDataGridSelectionCell_unstable;
    },
    dataGridSelectionCellClassNames: function() {
        return _reacttable.dataGridSelectionCellClassNames;
    },
    TableRowIdContextProvider: function() {
        return _reacttable.TableRowIdContextProvider;
    },
    useTableRowIdContext: function() {
        return _reacttable.useTableRowIdContext;
    },
    useTableColumnSizing_unstable: function() {
        return _reacttable.useTableColumnSizing_unstable;
    },
    ColumnIdContextProvider: function() {
        return _reacttable.ColumnIdContextProvider;
    },
    useColumnIdContext: function() {
        return _reacttable.useColumnIdContext;
    },
    TableHeaderContextProvider: function() {
        return _reacttable.TableHeaderContextProvider;
    },
    useIsInTableHeader: function() {
        return _reacttable.useIsInTableHeader;
    },
    Card: function() {
        return _reactcard.Card;
    },
    CardFooter: function() {
        return _reactcard.CardFooter;
    },
    CardHeader: function() {
        return _reactcard.CardHeader;
    },
    CardPreview: function() {
        return _reactcard.CardPreview;
    },
    cardClassNames: function() {
        return _reactcard.cardClassNames;
    },
    cardCSSVars: function() {
        return _reactcard.cardCSSVars;
    },
    cardFooterClassNames: function() {
        return _reactcard.cardFooterClassNames;
    },
    cardHeaderClassNames: function() {
        return _reactcard.cardHeaderClassNames;
    },
    cardHeaderCSSVars: function() {
        return _reactcard.cardHeaderCSSVars;
    },
    cardPreviewClassNames: function() {
        return _reactcard.cardPreviewClassNames;
    },
    renderCard_unstable: function() {
        return _reactcard.renderCard_unstable;
    },
    renderCardFooter_unstable: function() {
        return _reactcard.renderCardFooter_unstable;
    },
    renderCardHeader_unstable: function() {
        return _reactcard.renderCardHeader_unstable;
    },
    renderCardPreview_unstable: function() {
        return _reactcard.renderCardPreview_unstable;
    },
    useCard_unstable: function() {
        return _reactcard.useCard_unstable;
    },
    useCardFooter_unstable: function() {
        return _reactcard.useCardFooter_unstable;
    },
    useCardFooterStyles_unstable: function() {
        return _reactcard.useCardFooterStyles_unstable;
    },
    useCardHeader_unstable: function() {
        return _reactcard.useCardHeader_unstable;
    },
    useCardHeaderStyles_unstable: function() {
        return _reactcard.useCardHeaderStyles_unstable;
    },
    useCardPreview_unstable: function() {
        return _reactcard.useCardPreview_unstable;
    },
    useCardPreviewStyles_unstable: function() {
        return _reactcard.useCardPreviewStyles_unstable;
    },
    useCardStyles_unstable: function() {
        return _reactcard.useCardStyles_unstable;
    },
    Field: function() {
        return _reactfield.Field;
    },
    fieldClassNames: function() {
        return _reactfield.fieldClassNames;
    },
    FieldContextProvider: function() {
        return _reactfield.FieldContextProvider;
    },
    renderField_unstable: function() {
        return _reactfield.renderField_unstable;
    },
    useFieldContext_unstable: function() {
        return _reactfield.useFieldContext_unstable;
    },
    useFieldContextValues_unstable: function() {
        return _reactfield.useFieldContextValues_unstable;
    },
    useFieldControlProps_unstable: function() {
        return _reactfield.useFieldControlProps_unstable;
    },
    useFieldStyles_unstable: function() {
        return _reactfield.useFieldStyles_unstable;
    },
    useField_unstable: function() {
        return _reactfield.useField_unstable;
    },
    useToastController: function() {
        return _reacttoast.useToastController;
    },
    ToastTrigger: function() {
        return _reacttoast.ToastTrigger;
    },
    useToastTrigger_unstable: function() {
        return _reacttoast.useToastTrigger_unstable;
    },
    renderToastTrigger_unstable: function() {
        return _reacttoast.renderToastTrigger_unstable;
    },
    Toaster: function() {
        return _reacttoast.Toaster;
    },
    useToasterStyles_unstable: function() {
        return _reacttoast.useToasterStyles_unstable;
    },
    useToaster_unstable: function() {
        return _reacttoast.useToaster_unstable;
    },
    renderToaster_unstable: function() {
        return _reacttoast.renderToaster_unstable;
    },
    toasterClassNames: function() {
        return _reacttoast.toasterClassNames;
    },
    Toast: function() {
        return _reacttoast.Toast;
    },
    useToastStyles_unstable: function() {
        return _reacttoast.useToastStyles_unstable;
    },
    useToast_unstable: function() {
        return _reacttoast.useToast_unstable;
    },
    renderToast_unstable: function() {
        return _reacttoast.renderToast_unstable;
    },
    ToastTitle: function() {
        return _reacttoast.ToastTitle;
    },
    useToastTitleStyles_unstable: function() {
        return _reacttoast.useToastTitleStyles_unstable;
    },
    useToastTitle_unstable: function() {
        return _reacttoast.useToastTitle_unstable;
    },
    renderToastTitle_unstable: function() {
        return _reacttoast.renderToastTitle_unstable;
    },
    toastTitleClassNames: function() {
        return _reacttoast.toastTitleClassNames;
    },
    ToastBody: function() {
        return _reacttoast.ToastBody;
    },
    useToastBodyStyles_unstable: function() {
        return _reacttoast.useToastBodyStyles_unstable;
    },
    useToastBody_unstable: function() {
        return _reacttoast.useToastBody_unstable;
    },
    renderToastBody_unstable: function() {
        return _reacttoast.renderToastBody_unstable;
    },
    toastBodyClassNames: function() {
        return _reacttoast.toastBodyClassNames;
    },
    ToastFooter: function() {
        return _reacttoast.ToastFooter;
    },
    useToastFooterStyles_unstable: function() {
        return _reacttoast.useToastFooterStyles_unstable;
    },
    useToastFooter_unstable: function() {
        return _reacttoast.useToastFooter_unstable;
    },
    renderToastFooter_unstable: function() {
        return _reacttoast.renderToastFooter_unstable;
    },
    toastFooterClassNames: function() {
        return _reacttoast.toastFooterClassNames;
    },
    FlatTree: function() {
        return _reacttree.FlatTree;
    },
    FlatTreeItem: function() {
        return _reacttree.FlatTreeItem;
    },
    Tree: function() {
        return _reacttree.Tree;
    },
    TreeItem: function() {
        return _reacttree.TreeItem;
    },
    TreeItemLayout: function() {
        return _reacttree.TreeItemLayout;
    },
    TreeItemPersonaLayout: function() {
        return _reacttree.TreeItemPersonaLayout;
    },
    TreeItemProvider: function() {
        return _reacttree.TreeItemProvider;
    },
    TreeProvider: function() {
        return _reacttree.TreeProvider;
    },
    flatTreeClassNames: function() {
        return _reacttree.flatTreeClassNames;
    },
    flattenTree_unstable: function() {
        return _reacttree.flattenTree_unstable;
    },
    renderFlatTree_unstable: function() {
        return _reacttree.renderFlatTree_unstable;
    },
    renderTreeItemLayout_unstable: function() {
        return _reacttree.renderTreeItemLayout_unstable;
    },
    renderTreeItemPersonaLayout_unstable: function() {
        return _reacttree.renderTreeItemPersonaLayout_unstable;
    },
    renderTreeItem_unstable: function() {
        return _reacttree.renderTreeItem_unstable;
    },
    renderTree_unstable: function() {
        return _reacttree.renderTree_unstable;
    },
    treeClassNames: function() {
        return _reacttree.treeClassNames;
    },
    treeItemClassNames: function() {
        return _reacttree.treeItemClassNames;
    },
    treeItemLayoutClassNames: function() {
        return _reacttree.treeItemLayoutClassNames;
    },
    treeItemLevelToken: function() {
        return _reacttree.treeItemLevelToken;
    },
    treeItemPersonaLayoutClassNames: function() {
        return _reacttree.treeItemPersonaLayoutClassNames;
    },
    useFlatTreeContextValues_unstable: function() {
        return _reacttree.useFlatTreeContextValues_unstable;
    },
    useFlatTreeStyles_unstable: function() {
        return _reacttree.useFlatTreeStyles_unstable;
    },
    useFlatTree_unstable: function() {
        return _reacttree.useFlatTree_unstable;
    },
    useHeadlessFlatTree_unstable: function() {
        return _reacttree.useHeadlessFlatTree_unstable;
    },
    useTreeContextValues_unstable: function() {
        return _reacttree.useTreeContextValues_unstable;
    },
    useTreeContext_unstable: function() {
        return _reacttree.useTreeContext_unstable;
    },
    useSubtreeContext_unstable: function() {
        return _reacttree.useSubtreeContext_unstable;
    },
    useTreeItemContextValues_unstable: function() {
        return _reacttree.useTreeItemContextValues_unstable;
    },
    useTreeItemContext_unstable: function() {
        return _reacttree.useTreeItemContext_unstable;
    },
    useTreeItemLayoutStyles_unstable: function() {
        return _reacttree.useTreeItemLayoutStyles_unstable;
    },
    useTreeItemLayout_unstable: function() {
        return _reacttree.useTreeItemLayout_unstable;
    },
    useTreeItemPersonaLayoutStyles_unstable: function() {
        return _reacttree.useTreeItemPersonaLayoutStyles_unstable;
    },
    useTreeItemPersonaLayout_unstable: function() {
        return _reacttree.useTreeItemPersonaLayout_unstable;
    },
    useTreeItemStyles_unstable: function() {
        return _reacttree.useTreeItemStyles_unstable;
    },
    useTreeItem_unstable: function() {
        return _reacttree.useTreeItem_unstable;
    },
    useTreeStyles_unstable: function() {
        return _reacttree.useTreeStyles_unstable;
    },
    useTree_unstable: function() {
        return _reacttree.useTree_unstable;
    },
    Tag: function() {
        return _reacttags.Tag;
    },
    renderTag_unstable: function() {
        return _reacttags.renderTag_unstable;
    },
    tagClassNames: function() {
        return _reacttags.tagClassNames;
    },
    useTagStyles_unstable: function() {
        return _reacttags.useTagStyles_unstable;
    },
    useTag_unstable: function() {
        return _reacttags.useTag_unstable;
    },
    InteractionTag: function() {
        return _reacttags.InteractionTag;
    },
    renderInteractionTag_unstable: function() {
        return _reacttags.renderInteractionTag_unstable;
    },
    interactionTagClassNames: function() {
        return _reacttags.interactionTagClassNames;
    },
    useInteractionTagStyles_unstable: function() {
        return _reacttags.useInteractionTagStyles_unstable;
    },
    useInteractionTag_unstable: function() {
        return _reacttags.useInteractionTag_unstable;
    },
    useInteractionTagContextValues_unstable: function() {
        return _reacttags.useInteractionTagContextValues_unstable;
    },
    InteractionTagPrimary: function() {
        return _reacttags.InteractionTagPrimary;
    },
    interactionTagPrimaryClassNames: function() {
        return _reacttags.interactionTagPrimaryClassNames;
    },
    renderInteractionTagPrimary_unstable: function() {
        return _reacttags.renderInteractionTagPrimary_unstable;
    },
    useInteractionTagPrimaryStyles_unstable: function() {
        return _reacttags.useInteractionTagPrimaryStyles_unstable;
    },
    useInteractionTagPrimary_unstable: function() {
        return _reacttags.useInteractionTagPrimary_unstable;
    },
    InteractionTagSecondary: function() {
        return _reacttags.InteractionTagSecondary;
    },
    renderInteractionTagSecondary_unstable: function() {
        return _reacttags.renderInteractionTagSecondary_unstable;
    },
    interactionTagSecondaryClassNames: function() {
        return _reacttags.interactionTagSecondaryClassNames;
    },
    useInteractionTagSecondaryStyles_unstable: function() {
        return _reacttags.useInteractionTagSecondaryStyles_unstable;
    },
    useInteractionTagSecondary_unstable: function() {
        return _reacttags.useInteractionTagSecondary_unstable;
    },
    TagGroup: function() {
        return _reacttags.TagGroup;
    },
    renderTagGroup_unstable: function() {
        return _reacttags.renderTagGroup_unstable;
    },
    tagGroupClassNames: function() {
        return _reacttags.tagGroupClassNames;
    },
    useTagGroupStyles_unstable: function() {
        return _reacttags.useTagGroupStyles_unstable;
    },
    useTagGroup_unstable: function() {
        return _reacttags.useTagGroup_unstable;
    },
    useTagGroupContextValues_unstable: function() {
        return _reacttags.useTagGroupContextValues_unstable;
    },
    useTagAvatarContextValues_unstable: function() {
        return _reacttags.useTagAvatarContextValues_unstable;
    },
    MessageBar: function() {
        return _reactmessagebar.MessageBar;
    },
    useMessageBarStyles_unstable: function() {
        return _reactmessagebar.useMessageBarStyles_unstable;
    },
    useMessageBar_unstable: function() {
        return _reactmessagebar.useMessageBar_unstable;
    },
    renderMessageBar_unstable: function() {
        return _reactmessagebar.renderMessageBar_unstable;
    },
    messageBarClassNames: function() {
        return _reactmessagebar.messageBarClassNames;
    },
    MessageBarTitle: function() {
        return _reactmessagebar.MessageBarTitle;
    },
    useMessageBarTitleStyles_unstable: function() {
        return _reactmessagebar.useMessageBarTitleStyles_unstable;
    },
    useMessageBarTitle_unstable: function() {
        return _reactmessagebar.useMessageBarTitle_unstable;
    },
    renderMessageBarTitle_unstable: function() {
        return _reactmessagebar.renderMessageBarTitle_unstable;
    },
    messageBarTitleClassNames: function() {
        return _reactmessagebar.messageBarTitleClassNames;
    },
    MessageBarActions: function() {
        return _reactmessagebar.MessageBarActions;
    },
    useMessageBarActionsStyles_unstable: function() {
        return _reactmessagebar.useMessageBarActionsStyles_unstable;
    },
    useMessageBarActions_unstable: function() {
        return _reactmessagebar.useMessageBarActions_unstable;
    },
    renderMessageBarActions_unstable: function() {
        return _reactmessagebar.renderMessageBarActions_unstable;
    },
    messageBarActionsClassNames: function() {
        return _reactmessagebar.messageBarActionsClassNames;
    },
    MessageBarBody: function() {
        return _reactmessagebar.MessageBarBody;
    },
    useMessageBarBodyStyles_unstable: function() {
        return _reactmessagebar.useMessageBarBodyStyles_unstable;
    },
    useMessageBarBody_unstable: function() {
        return _reactmessagebar.useMessageBarBody_unstable;
    },
    renderMessageBarBody_unstable: function() {
        return _reactmessagebar.renderMessageBarBody_unstable;
    },
    messageBarBodyClassNames: function() {
        return _reactmessagebar.messageBarBodyClassNames;
    },
    MessageBarContextProvider: function() {
        return _reactmessagebar.MessageBarContextProvider;
    },
    useMessageBarContext: function() {
        return _reactmessagebar.useMessageBarContext;
    },
    MessageBarGroup: function() {
        return _reactmessagebar.MessageBarGroup;
    },
    useMessageBarGroupStyles_unstable: function() {
        return _reactmessagebar.useMessageBarGroupStyles_unstable;
    },
    useMessageBarGroup_unstable: function() {
        return _reactmessagebar.useMessageBarGroup_unstable;
    },
    renderMessageBarGroup_unstable: function() {
        return _reactmessagebar.renderMessageBarGroup_unstable;
    },
    messageBarGroupClassNames: function() {
        return _reactmessagebar.messageBarGroupClassNames;
    },
    InfoLabel: function() {
        return _reactinfolabel.InfoLabel;
    },
    infoLabelClassNames: function() {
        return _reactinfolabel.infoLabelClassNames;
    },
    renderInfoLabel_unstable: function() {
        return _reactinfolabel.renderInfoLabel_unstable;
    },
    useInfoLabelStyles_unstable: function() {
        return _reactinfolabel.useInfoLabelStyles_unstable;
    },
    useInfoLabel_unstable: function() {
        return _reactinfolabel.useInfoLabel_unstable;
    },
    Drawer: function() {
        return _reactdrawer.Drawer;
    },
    renderDrawer_unstable: function() {
        return _reactdrawer.renderDrawer_unstable;
    },
    useDrawerStyles_unstable: function() {
        return _reactdrawer.useDrawerStyles_unstable;
    },
    useDrawer_unstable: function() {
        return _reactdrawer.useDrawer_unstable;
    },
    OverlayDrawer: function() {
        return _reactdrawer.OverlayDrawer;
    },
    overlayDrawerClassNames: function() {
        return _reactdrawer.overlayDrawerClassNames;
    },
    renderOverlayDrawer_unstable: function() {
        return _reactdrawer.renderOverlayDrawer_unstable;
    },
    useOverlayDrawerStyles_unstable: function() {
        return _reactdrawer.useOverlayDrawerStyles_unstable;
    },
    useOverlayDrawer_unstable: function() {
        return _reactdrawer.useOverlayDrawer_unstable;
    },
    InlineDrawer: function() {
        return _reactdrawer.InlineDrawer;
    },
    inlineDrawerClassNames: function() {
        return _reactdrawer.inlineDrawerClassNames;
    },
    renderInlineDrawer_unstable: function() {
        return _reactdrawer.renderInlineDrawer_unstable;
    },
    useInlineDrawerStyles_unstable: function() {
        return _reactdrawer.useInlineDrawerStyles_unstable;
    },
    useInlineDrawer_unstable: function() {
        return _reactdrawer.useInlineDrawer_unstable;
    },
    DrawerBody: function() {
        return _reactdrawer.DrawerBody;
    },
    drawerBodyClassNames: function() {
        return _reactdrawer.drawerBodyClassNames;
    },
    renderDrawerBody_unstable: function() {
        return _reactdrawer.renderDrawerBody_unstable;
    },
    useDrawerBodyStyles_unstable: function() {
        return _reactdrawer.useDrawerBodyStyles_unstable;
    },
    useDrawerBody_unstable: function() {
        return _reactdrawer.useDrawerBody_unstable;
    },
    DrawerHeader: function() {
        return _reactdrawer.DrawerHeader;
    },
    drawerHeaderClassNames: function() {
        return _reactdrawer.drawerHeaderClassNames;
    },
    renderDrawerHeader_unstable: function() {
        return _reactdrawer.renderDrawerHeader_unstable;
    },
    useDrawerHeaderStyles_unstable: function() {
        return _reactdrawer.useDrawerHeaderStyles_unstable;
    },
    useDrawerHeader_unstable: function() {
        return _reactdrawer.useDrawerHeader_unstable;
    },
    DrawerHeaderTitle: function() {
        return _reactdrawer.DrawerHeaderTitle;
    },
    drawerHeaderTitleClassNames: function() {
        return _reactdrawer.drawerHeaderTitleClassNames;
    },
    renderDrawerHeaderTitle_unstable: function() {
        return _reactdrawer.renderDrawerHeaderTitle_unstable;
    },
    useDrawerHeaderTitleStyles_unstable: function() {
        return _reactdrawer.useDrawerHeaderTitleStyles_unstable;
    },
    useDrawerHeaderTitle_unstable: function() {
        return _reactdrawer.useDrawerHeaderTitle_unstable;
    },
    DrawerHeaderNavigation: function() {
        return _reactdrawer.DrawerHeaderNavigation;
    },
    drawerHeaderNavigationClassNames: function() {
        return _reactdrawer.drawerHeaderNavigationClassNames;
    },
    renderDrawerHeaderNavigation_unstable: function() {
        return _reactdrawer.renderDrawerHeaderNavigation_unstable;
    },
    useDrawerHeaderNavigationStyles_unstable: function() {
        return _reactdrawer.useDrawerHeaderNavigationStyles_unstable;
    },
    useDrawerHeaderNavigation_unstable: function() {
        return _reactdrawer.useDrawerHeaderNavigation_unstable;
    },
    DrawerFooter: function() {
        return _reactdrawer.DrawerFooter;
    },
    drawerFooterClassNames: function() {
        return _reactdrawer.drawerFooterClassNames;
    },
    renderDrawerFooter_unstable: function() {
        return _reactdrawer.renderDrawerFooter_unstable;
    },
    useDrawerFooterStyles_unstable: function() {
        return _reactdrawer.useDrawerFooterStyles_unstable;
    },
    useDrawerFooter_unstable: function() {
        return _reactdrawer.useDrawerFooter_unstable;
    },
    Breadcrumb: function() {
        return _reactbreadcrumb.Breadcrumb;
    },
    renderBreadcrumb_unstable: function() {
        return _reactbreadcrumb.renderBreadcrumb_unstable;
    },
    useBreadcrumb_unstable: function() {
        return _reactbreadcrumb.useBreadcrumb_unstable;
    },
    useBreadcrumbStyles_unstable: function() {
        return _reactbreadcrumb.useBreadcrumbStyles_unstable;
    },
    breadcrumbClassNames: function() {
        return _reactbreadcrumb.breadcrumbClassNames;
    },
    BreadcrumbDivider: function() {
        return _reactbreadcrumb.BreadcrumbDivider;
    },
    breadcrumbDividerClassNames: function() {
        return _reactbreadcrumb.breadcrumbDividerClassNames;
    },
    renderBreadcrumbDivider_unstable: function() {
        return _reactbreadcrumb.renderBreadcrumbDivider_unstable;
    },
    useBreadcrumbDividerStyles_unstable: function() {
        return _reactbreadcrumb.useBreadcrumbDividerStyles_unstable;
    },
    useBreadcrumbDivider_unstable: function() {
        return _reactbreadcrumb.useBreadcrumbDivider_unstable;
    },
    BreadcrumbItem: function() {
        return _reactbreadcrumb.BreadcrumbItem;
    },
    breadcrumbItemClassNames: function() {
        return _reactbreadcrumb.breadcrumbItemClassNames;
    },
    renderBreadcrumbItem_unstable: function() {
        return _reactbreadcrumb.renderBreadcrumbItem_unstable;
    },
    useBreadcrumbItemStyles_unstable: function() {
        return _reactbreadcrumb.useBreadcrumbItemStyles_unstable;
    },
    useBreadcrumbItem_unstable: function() {
        return _reactbreadcrumb.useBreadcrumbItem_unstable;
    },
    partitionBreadcrumbItems: function() {
        return _reactbreadcrumb.partitionBreadcrumbItems;
    },
    truncateBreadcrumbLongName: function() {
        return _reactbreadcrumb.truncateBreadcrumbLongName;
    },
    truncateBreadcrumLongTooltip: function() {
        return _reactbreadcrumb.truncateBreadcrumLongTooltip;
    },
    isTruncatableBreadcrumbContent: function() {
        return _reactbreadcrumb.isTruncatableBreadcrumbContent;
    },
    BreadcrumbButton: function() {
        return _reactbreadcrumb.BreadcrumbButton;
    },
    breadcrumbButtonClassNames: function() {
        return _reactbreadcrumb.breadcrumbButtonClassNames;
    },
    renderBreadcrumbButton_unstable: function() {
        return _reactbreadcrumb.renderBreadcrumbButton_unstable;
    },
    useBreadcrumbButtonStyles_unstable: function() {
        return _reactbreadcrumb.useBreadcrumbButtonStyles_unstable;
    },
    useBreadcrumbButton_unstable: function() {
        return _reactbreadcrumb.useBreadcrumbButton_unstable;
    },
    BreadcrumbProvider: function() {
        return _reactbreadcrumb.BreadcrumbProvider;
    },
    useBreadcrumbContext_unstable: function() {
        return _reactbreadcrumb.useBreadcrumbContext_unstable;
    },
    AriaLiveAnnouncer: function() {
        return _reactaria.AriaLiveAnnouncer;
    },
    renderAriaLiveAnnouncer_unstable: function() {
        return _reactaria.renderAriaLiveAnnouncer_unstable;
    },
    useAriaLiveAnnouncer_unstable: function() {
        return _reactaria.useAriaLiveAnnouncer_unstable;
    },
    useAriaLiveAnnouncerContextValues_unstable: function() {
        return _reactaria.useAriaLiveAnnouncerContextValues_unstable;
    }
});
const _react = require("@griffel/react");
const _reactprovider = require("@fluentui/react-provider");
const _reacttabster = require("@fluentui/react-tabster");
const _reacttheme = require("@fluentui/react-theme");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _reactutilities = require("@fluentui/react-utilities");
const _reactaccordion = require("@fluentui/react-accordion");
const _reactavatar = require("@fluentui/react-avatar");
const _reactbadge = require("@fluentui/react-badge");
const _reactbutton = require("@fluentui/react-button");
const _reactcheckbox = require("@fluentui/react-checkbox");
const _reactcombobox = require("@fluentui/react-combobox");
const _reactdivider = require("@fluentui/react-divider");
const _reactinput = require("@fluentui/react-input");
const _reactimage = require("@fluentui/react-image");
const _reactlabel = require("@fluentui/react-label");
const _reactlink = require("@fluentui/react-link");
const _reactmenu = require("@fluentui/react-menu");
const _reactpersona = require("@fluentui/react-persona");
const _reactpopover = require("@fluentui/react-popover");
const _reactportal = require("@fluentui/react-portal");
const _reactradio = require("@fluentui/react-radio");
const _reactselect = require("@fluentui/react-select");
const _reactskeleton = require("@fluentui/react-skeleton");
const _reactslider = require("@fluentui/react-slider");
const _reactspinbutton = require("@fluentui/react-spinbutton");
const _reactspinner = require("@fluentui/react-spinner");
const _reactswitch = require("@fluentui/react-switch");
const _reacttabs = require("@fluentui/react-tabs");
const _reacttext = require("@fluentui/react-text");
const _reacttextarea = require("@fluentui/react-textarea");
const _reacttooltip = require("@fluentui/react-tooltip");
const _reactpositioning = require("@fluentui/react-positioning");
const _reactdialog = require("@fluentui/react-dialog");
const _reactprogress = require("@fluentui/react-progress");
const _reactoverflow = require("@fluentui/react-overflow");
const _reacttoolbar = require("@fluentui/react-toolbar");
const _reacttable = require("@fluentui/react-table");
const _reactcard = require("@fluentui/react-card");
const _reactfield = require("@fluentui/react-field");
const _reacttoast = require("@fluentui/react-toast");
const _reacttree = require("@fluentui/react-tree");
const _reacttags = require("@fluentui/react-tags");
const _reactmessagebar = require("@fluentui/react-message-bar");
const _reactinfolabel = require("@fluentui/react-infolabel");
const _reactdrawer = require("@fluentui/react-drawer");
const _reactbreadcrumb = require("@fluentui/react-breadcrumb");
const _reactaria = require("@fluentui/react-aria");
